export default class VueModel {
    private _app: null | any = null;

    // ---> Getters
    public getApp(): null | any { return this._app; }

    // ---> Setters
    public setApp(app: any): void { this._app = app; }
}
